function isDebug(key: string): boolean {
    return localStorage.getItem(key)?.toLocaleLowerCase() === 'true';
}

export const isBlocDebugAllowed = () => isDebug('debug_bloc');
export const isI18nDebugAllowed = () => isDebug('debug_i18n');
